import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import ReactGA from "react-ga4";
import { createBrowserHistory } from 'history'
import "./scss/light-theme.scss";
import "./scss/dark-theme.scss";
import "./scss/animation.scss";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import PageNotFound from "./views/PageNotFound";
import SearchResults from "./views/SearchResults";
import WhatsNewPopup from "./components/WhatsNewPopup";
import { contentRoutes } from "./routes/contentRoutes";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.history = createBrowserHistory();
    }

    componentDidMount() {
        window.process = {
            ...window.process,
        };

        // Initialize Google Analytics
        const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;
        ReactGA.initialize(TRACKING_ID);

        // Track the initial page load
        ReactGA.send({
            hitType: 'pageview',
            page: window.location.pathname + window.location.search
        });

        // Set up history listener
        this.history.listen((location) => {
            ReactGA.send({
                hitType: 'pageview',
                page: location.pathname
            });
        });
    }

    render() {
        return (
            <div>
                <div id="return-top"></div>
                <Router history={this.history} basename={process.env.PUBLIC_URL}>
                    <WhatsNewPopup />
                    <ScrollToTop />
                    <Navigation />
                    <div className="container body-content">
                        <Routes>
                            {contentRoutes.map(({ path, Component }) => (
                                <Route
                                    key={path}
                                    exact
                                    path={path}
                                    element={<Component />}
                                ></Route>
                            ))}
                            <Route
                                exact
                                path="/search/:searchQuery?"
                                element={<SearchResults />}
                            ></Route>
                            <Route
                                exact
                                path="*"
                                element={<PageNotFound />}
                            ></Route>
                        </Routes>
                        <Footer />
                    </div>
                    <div className="disclaimer">
                        Images used and graphics made on this site may use content
                        from Toontown Rewritten or Disney's Toontown Online. I do
                        not claim ownership of this content.
                    </div>
                </Router>
            </div>
        );
    }
}

export default App;
